"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCancellationReason = exports.setCancellationReasons = exports.setProvider = exports.setCancelParameters = exports.setAppointment = void 0;
const xstate_1 = require("xstate");
const setAppointment = '@action/SET_APPOINTMENT';
exports.setAppointment = setAppointment;
const setCancelParameters = '@action/SET_CANCEL_PARAMETERS';
exports.setCancelParameters = setCancelParameters;
const setProvider = '@action/SET_PROVIDER';
exports.setProvider = setProvider;
const setCancellationReasons = '@action/SET_CANCELLATION_REASONS';
exports.setCancellationReasons = setCancellationReasons;
const setCancellationReason = '@action/SET_CANCELLATION_REASON';
exports.setCancellationReason = setCancellationReason;
const actions = {
    [setAppointment]: (0, xstate_1.assign)({
        appointment: (_context, event) => {
            return event.data.appointment;
        },
        locationId: (_context, event) => {
            return event.data.locationId;
        },
        providerId: (_context, event) => {
            return event.data.providerId;
        },
        capabilities: (_context, event) => {
            var _a, _b;
            const { capabilities } = event.data;
            return {
                isCancelEnabled: (_a = capabilities === null || capabilities === void 0 ? void 0 : capabilities.cancel) === null || _a === void 0 ? void 0 : _a.enabled,
                isRescheduleEnabled: (_b = capabilities === null || capabilities === void 0 ? void 0 : capabilities.reschedule) === null || _b === void 0 ? void 0 : _b.enabled
            };
        },
        appointmentQuery: (_context, event) => {
            const { appointment } = event.data;
            return {
                patientRel: appointment === null || appointment === void 0 ? void 0 : appointment.patient_relationship,
                purpose: {
                    name: appointment === null || appointment === void 0 ? void 0 : appointment.purpose_name
                }
            };
        }
    }),
    [setProvider]: (0, xstate_1.assign)({
        provider: (_context, event) => {
            return event.data;
        },
        locations: (_context, event) => {
            return event.data.locations;
        }
    }),
    [setCancelParameters]: (0, xstate_1.assign)({
        cancelEmailConsent: (_context, event) => {
            return event.data.cancelEmailConsent;
        },
        cancelReasonText: (_context, event) => {
            return event.data.cancelReasonText;
        }
    }),
    [setCancellationReasons]: (0, xstate_1.assign)({
        cancellationReasons: (_context, event) => {
            return event.data;
        }
    }),
    [setCancellationReason]: (0, xstate_1.assign)({
        selectedCancellationReason: (_context, event) => event.data
    })
};
exports.default = actions;
//# sourceMappingURL=actions.js.map